import { EventUI, ImageHero, NextServiceCard } from "@jesus-central-church/ui";
import { SbBlokData, StoryblokServerComponent } from "@storyblok/react/rsc";
import React from "react";
import { getNextServiceEvent, type SbImageHero } from "./../../index";

interface SbImageHeroProperties {
  blok: SbImageHero & SbBlokData;
  pageData: { locale: string };
}

export const ImageHeroComponent: React.FC<SbImageHeroProperties> = async ({
  blok,
  pageData,
}) => {
  let nextService: EventUI | null = null;

  if (blok.showNextService) {
    nextService = await getNextServiceEvent(pageData.locale);
  }


  return (
    <ImageHero
      imageAlt={blok.image.alt || "Image Hero"}
      imageSrc={blok.image.filename!}
      title={blok.title}
      subtitle={blok.subtitle}
      nextServiceComponent={
        nextService ? (
          <NextServiceCard
            serviceDate={new Date(nextService.startDateTime)}
            title={nextService.title}
            location={nextService.location}
          />
        ) : null
      }
    >
      {blok.buttons?.map((button) => (
        <StoryblokServerComponent
          key={button._uid}
          blok={button}
          pageData={pageData}
        />
      ))}
    </ImageHero>
  );
};
